import { render, staticRenderFns } from "./ReceivablesAgingReport.vue?vue&type=template&id=951cd7ba"
import script from "./ReceivablesAgingReport.vue?vue&type=script&lang=js"
export * from "./ReceivablesAgingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports